import React, { useEffect, useMemo, useRef, useState } from "react";
import { useFormik } from "formik";
import { remove } from "lodash";
import { useDropzone } from "react-dropzone";
import Compressor from "compressorjs";
import { useAtom } from "jotai";

import {
  formConfigDermatose,
  formConfigTummerCutane,
} from "../../config/formConfig";
import {
  analyzeImage,
  dispatchOrUpdateDraft,
  getAllAvailableExperts,
  loadImageConverteds,
  loadImages,
  retriveDemande,
} from "../../api/medecin";
import { getYupSchemaFromMetaData } from "./yupSchemaCreator";
import alert from "../../assets/images/alert.png";

import RecursiveContainer from "./RecursiveContainer";
import Button from "../ButtonUI";
import Spinner from "../Spinner";
import Select from "../Select";
import makeToast from "../Snackbar";

import { refreshAtomRequest } from "../../state/refreshRequestList";
import { userAtom } from "../../state/auth";

import { ReactComponent as Close } from "../../assets/icons/icon-close.svg";
import _ from "lodash";
import { retriveGroup } from "../../api/groups";
import Carousel from "../Carousel";
import HumanCard from "../HumanCard";
import { HiCheckCircle } from 'react-icons/hi';
import { MdCameraAlt, MdAccessibilityNew } from 'react-icons/md';
import { QualityAnalysis } from "./QualityImage";
import { hydrate } from "react-dom";
type QualityResult = {
  blur_variance: number;
  brightness_mean: number;
  brightness_status: string;
  contrast_std: number;
  filename: string;
  is_blurry: boolean;
  low_contrast: boolean;
  overall_quality: string;
};
interface IDocumentFile {
  _id: string;
  specialite: string;
  patientId: string;
  filePath: string;
  bodyPart?: string;
  message?: string;
  anciennete?: string;
  douleur?: "oui" | "non" | "inconnue";
  taille?: string;
}

interface Entry {
  selectedPart: string | null;
  files: any[];
  message: string;
  anciennete?: string;
  douleur?: "oui" | "non" | "inconnue";
  taille?: string;
}

const specialites = [{ label: "Dermatologie", value: "dermatologie" }];

const category = [
  { label: "Dermatose non tumorale", value: "Dermatose non tumorale" },
  { label: "Tumeurs cutanees", value: "Tumeurs cutanees" },
];
const parseImage = async(specialite, userId, filePath, id) => ({
  original: await loadImages(specialite, userId, "thumbnail", filePath),
  id: id,
});
const urlToFile = async (url: string, filename = "image.jpg") => {
  const res = await fetch(url);
  const blob = await res.blob();
  return new File([blob], filename, { type: blob.type });
};
const DynamicContainer: React.FC<any> = ({
  setOpenModal,
  gender,
  formConfig,
  props,
}) => {
  const [parsedImages, setParsedImages] = useState([]) as any[];
  const [loading, setLoading] = useState(false);
  const [demandeInfo, setDemandeInfo] = useState<any>();
  const [documentsList, setDocumentsList] = useState<IDocumentFile[]>([]);
  const [user, setUser] = useAtom(userAtom);
  const [oldImgs, setOldImgs] = useState([]) as any[];
  const [refresh, setRefresh] = useAtom(refreshAtomRequest);
  const [filesX, setFilesx] = useState<any>([]);
  const [progress, setProgress] = useState(0);
  const [uploadToast, setUploadToast] = useState(false);
  const [teleexpertList, setTeleexpertList] = useState<any[]>([]);
  const [previousDoctor, setPreviousDoctor] = useState<any[]>([]);
  const [groupData, setGroupData] = useState("") as any;
  const [dispatch, setDispatch] = useState(true);
  //const [isIPhone, setIsIPhone] = useState(false);
  const [withPics, setWithPics] = useState(
    documentsList && documentsList.length > 0 ? false : true
  );
  const [currentIndex, setCurrentIndex] = useState(0);
    const [confirm, setConfirm] = useState(false);
  const [entries, setEntries] = useState<Entry[]>([
      { selectedPart: null, files: [], message: "" },
    ]);
  const currentEntry = entries[currentIndex] ?? {
    selectedPart: null,
    files: [],
    message: "",
    anciennete: "",
    douleur: "inconnue",
    taille: "",
  };
  
  const [qualityData, setQualityData] = useState<QualityResult | null>(null);
  const cameraInputRef = useRef<HTMLInputElement>(null);

  const handleDeleteImage = (entryIndex: number, imageIndex: number) => {
    setEntries((prev) => {
      const updated = [...prev];

      const entry = updated[entryIndex];
      if (!entry) return prev;

      const newFiles = entry.files.filter((_, idx) => idx !== imageIndex);

      updated[entryIndex] = {
        ...entry,
        files: newFiles,
      };

      if (entryIndex === currentIndex && newFiles.length === 0) {
        setConfirm(false);
      }

      return updated;
    });
  };
  const handleDeleteEntry = (entryIndex: number) => {
    setEntries((prev) => {
      const updated = prev.filter((_, idx) => idx !== entryIndex);

      if (updated.length === 0) {
        setConfirm(false);
        setCurrentIndex(0);

        return [
          {
            selectedPart: null,
            files: [],
            message: "",
            anciennete: "",
            douleur: "inconnue",
            taille: "",
          },
        ];
      }

      return updated;
    });

    setCurrentIndex((prev) => Math.max(0, prev - 1));
  };

  const removeLastPhoto = () => {
    setEntries(prev => {
      const updated = [...prev];
      const entry = updated[currentIndex];
      
      if (!entry) return prev;

      entry.files = entry.files.slice(0, -1);

      if (entry.files.length === 0) {
        entry.selectedPart = null;
        entry.message = "";
        entry.anciennete= "";
        entry.douleur= undefined;
        entry.taille= "";
        setConfirm(false);
      }

      updated[currentIndex] = entry;
      return updated;
    });

    setQualityData(null);
  };
  /**
   * const isIOS =
  /iPad|iPhone|iPod/.test(navigator.userAgent) ||
  (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);

  !isios
   */
  const processFiles = (files: File[]) => {
    files.forEach((file) => {
      console.log("Processing file:", file);
  
      new Compressor(file, {
        quality: 0.8,
        maxWidth: 2048,
        maxHeight: 2048,
        success: async (blob) => {
          const compressedFile = new File([blob], file.name || "camera_photo.jpg", {
            type: blob.type,
          });
  
          setEntries((prev) =>
            prev.map((entry, idx) => {
              if (idx !== currentIndex) return entry;
  
              const safeEntry = entry ?? {
                selectedPart: null,
                files: [],
                message: "",
                anciennete: "",
                taille: "",
                douleur: "inconnue",
              };
  
              return {
                ...safeEntry,
                files: [...safeEntry.files, compressedFile],
              };
            })
          );
  
          try {
            const formData = new FormData();
            formData.append("image", compressedFile);
  
            const res = await analyzeImage(formData);
            const result = res.data.data.results[0];
            console.log("Analysis result:", result);
            setQualityData(result);
  
            if (result.overall_quality !== "accept") {
              makeToast(
                "error",
                "La photo est de mauvaise qualité. Veuillez prendre une autre photo."
              );
            }
          } catch (err) {
            console.error("Error sending image for analysis:", err);
          }
        },
      });
    });
  };
  const { getRootProps, getInputProps } = useDropzone({
    accept: ["image/png", "image/jpeg", "image/jpg", "image/webp"],
    onDrop: (acceptedFiles) => processFiles(acceptedFiles),
  });

  const handleCameraCapture = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files.length > 0) {
      const capturedFiles = Array.from(e.target.files);
      processFiles(capturedFiles);
      e.target.value = "";
    }
  };
  useEffect(() => {
    async function fetchMyAPI(): Promise<void> {
      const response = await getAllAvailableExperts({
        userId: user?._id,
        patientId: props.patient._id,
      });
      setTeleexpertList(response?.filterListOfAvailableDoctor);
      setPreviousDoctor(
        response?.ListPreviousDoctors
          ? response?.ListPreviousDoctors.map((el) => ({
              ...el,
              label:
                el.lastName +
                " " +
                el.firstName +
                " " +
                "(" +
                "a précédemment traité une demande sur ce même patient" +
                ")",
              value: el._id,
            }))
          : []
      );
    }

    fetchMyAPI();
  }, []);
  async function retriveGroupMyAPI() {
    setLoading(true);
    const res = await retriveGroup(user?.groupId);
    setGroupData(res?.response);
    setLoading(false);
    return await res;
  }
  useEffect(() => {
    retriveGroupMyAPI();
  }, []);

  useEffect(() => {
    async function fetchMyAPI(): Promise<void> {
      const response = await getAllAvailableExperts({
        userId: user?._id,
        patientId: props.patient._id,
      });
      setTeleexpertList(response?.filterListOfAvailableDoctor);
      const uniquePreviousDoctorIds: string[] = [];
      setPreviousDoctor(
        (response?.ListPreviousDoctors || [])
          .map((el) => {
            if (!uniquePreviousDoctorIds.includes(el._id)) {
              uniquePreviousDoctorIds.push(el._id);
              return {
                ...el,
                label:
                  el.lastName +
                  " " +
                  el.firstName +
                  " " +
                  "(" +
                  "a précédémment traité une demande sur ce même patient" +
                  ")",
                value: el._id,
              };
            }
            return null;
          })
          .filter(Boolean)
      );
      setLoading(false);
    }

    fetchMyAPI();
  }, []);

  useEffect(() => {
    const imgs = [] as any;
    documentsList?.map((img) => {
      imgs.push(
        parseImage(img.specialite, img.patientId, img.filePath, img._id)
      );
    });
    setParsedImages(imgs);
  }, [documentsList]);
  useEffect(() => {
    setOldImgs(parsedImages.map((p) => p.id));
  }, [parsedImages]);

  const thumbs = filesX.map((file) => (
    <div className="thumb" key={file?.preview as any}>
      <div className="thumbInner">
        <span
          className="absolute icon-secondary2"
          onClick={() => {
            setFilesx(
              remove([...filesX], function (n) {
                return n.preview !== file.preview;
              })
            );
          }}
        >
          <Close />
        </span>
        <img src={file.preview} alt="img drop" className="img" />
      </div>
    </div>
  ));
  const getInitialValues = () => {
  
  const currentType = demandeInfo?.type || props.type;
  
  const activeConfig = currentType === "Dermatose non tumorale" 
    ? formConfigDermatose 
    : formConfigTummerCutane;

  const baseValues = {
    demandeId: props.demandeId,
    ...(demandeInfo?.interrogatoire?.other || {}),
    type: currentType,
    withPhotos: withPics,
    constId: "69ce7ee7d718b7b424e9a893",
    status: demandeInfo?.status || props.status,
    specialite: demandeInfo?.specialite || props.specialite,
    patientId: props.patient._id,
    docReq: user?._id,
    doctor_id: user?._id,
    priseEncharge: demandeInfo?.priseEncharge || props.priseEncharge,
    docExpert: demandeInfo?.docExpert || props.docExpert || "",
  };

  // map the info
  activeConfig.forEach((f) => {
    const apiValue = demandeInfo?.[f.field] ?? demandeInfo?.interrogatoire?.other?.[f.field];
    
    if (apiValue !== undefined && apiValue !== null) {
    
    // remove the undefined
    if (apiValue === "undefined") {
      baseValues[f.field] = ""; 
      return;
    }

    if (f.type === "only_Creatable" || f.type === "arrayWithCondition") {
      if (Array.isArray(apiValue)) {
        baseValues[f.field] = apiValue;
      } else if (typeof apiValue === "string") {
        baseValues[f.field] = apiValue.split(",").filter(Boolean);
      }
    } else {
        baseValues[f.field] = apiValue;
      }
    } else {
      //do nothning 
      //baseValues[f.field] = (f.value === "undefined" || !f.value) ? "" : f.value;
    }
  });

  return baseValues;
};
  const intialVal: any = {};
  intialVal["demandeId"] = props.demandeId;
  intialVal["type"] = props.type;
  intialVal["withPhotos"] = withPics;
  intialVal["constId"] = "69ce7ee7d718b7b424e9a893";
  intialVal["status"] = props.status;
  intialVal["specialite"] = props.specialite;
  intialVal["patientId"] = props.patient._id;
  intialVal["docReq"] = user?._id;
  intialVal["doctor_id"] = user?._id;
  intialVal["priseEncharge"] = props.priseEncharge;
  intialVal["docExpert"] = props.docExpert;

  formConfig.map((f) => {
    if (f.value && f.value !== "undefined") {
      let readyData = [];
      if (f.type === "only_Creatable" || f.type === "arrayWithCondition") {
        const arr =
          f.value && f.value !== "undefined" ? f.value.split(",") : [];
        readyData = arr.map((a) => {
          return a;
        });
        intialVal[`${f.field}`] = readyData;
      } else {
        intialVal[`${f.field}`] = f.value;
      }
    }
  });
  useEffect(() => {
    return () => {
      entries.forEach(entry =>
        entry.files.forEach(file => {
          if (file.preview?.startsWith("blob:")) {
            URL.revokeObjectURL(file.preview);
          }
        })
      );
    };
  }, [entries]);

  async function retriveDemandeMyAPI() {
    setLoading(true);
    const res = await retriveDemande(props?.demandeId);
    setDemandeInfo(res?.data?.demande);
    setDocumentsList(res?.data?.demande?.files);
    setLoading(false);
    return await res;
  }
  useEffect(() => {
    retriveDemandeMyAPI();
  }, []);

  const formik = useFormik({
    initialValues: getInitialValues(),
    enableReinitialize: true,
    onSubmit: async (values) => {
      try {
        let formConfig = {};

        if (values.type === "Dermatose non tumorale") {
          formConfig = formConfigDermatose;
        } else if (values.type === "Tumeurs cutanees") {
          formConfig = formConfigTummerCutane;
        }

        values.dispatch = dispatch;

        values.oldImgs = oldImgs;
        
        setLoading(true);
        if (withPics) {
          setUploadToast(true);
        }
        //entries
        const allFiles = entries.flatMap(entry => 
          entry.files.map(file => ({
            file: file,
            bodyPart: entry.selectedPart || "", 
            message: entry.message || "",
            anciennete: entry.anciennete || "",
            douleur: entry.douleur || "",
            taille: entry.taille || ""
          }))
        );
        values.withPhotos = allFiles.length > 0;
        
        const fileObjects = allFiles.map(f => f.file);
        const metaArray = allFiles.map(f => ({
          bodyPart: f.bodyPart,
          message: f.message,
          anciennete: f.anciennete || "",
          douleur: f.douleur || "",
          taille: f.taille || ""
        }));

        const response = await dispatchOrUpdateDraft(
          {
            ...values,
            files: fileObjects,
            meta:metaArray
          },
          formConfig,
          (event: { loaded: number; total: number }) => {
            setProgress(Math.round((100 * event.loaded) / event.total));

            return event.loaded;
          }
        );
        setOpenModal(false);

        if (response) {
          setRefresh({ state: !refresh?.state });
          makeToast("success", response?.message);
          setLoading(false);
        } else {
          setLoading(false);
          makeToast("error", response?.message);
        }
      } catch (error) {
        console.error(error);
        setLoading(false);
        makeToast(
          "error",
          "Vous n'êtes pas autorisé à transmettre cette demande de téléexpertise! "
        );
        setOpenModal(false);
      }
    },

    validationSchema:
      dispatch &&
      getYupSchemaFromMetaData(
        props.type === "Dermatose non tumorale"
          ? formConfigDermatose
          : formConfigTummerCutane,
        [],
        []
      ),
  });

  useEffect(() => {
    if (!documentsList?.length) return;

    const hydrate = async () => {
      const hydratedEntries = await Promise.all(
        documentsList.map(async (doc) => {
          const imageUrl = await loadImageConverteds(
            doc.specialite,
            doc.patientId,
            "thumbnail",
            doc.filePath
          );

          const file = await urlToFile(imageUrl, doc.filePath);

          const fileWithPreview = Object.assign(file, {
            preview: URL.createObjectURL(file),
          });

          return {
            selectedPart: doc.bodyPart || null,
            message: doc.message || "",
            anciennete: doc.anciennete || "",
            douleur: doc.douleur || undefined,
            taille: doc.taille || "",
            files: [fileWithPreview],
          };
        })
      );

      setEntries(hydratedEntries);
    };

    hydrate();
  }, [documentsList]);

  /*useEffect(() => {
    if (typeof window !== 'undefined') {
      const userAgent = navigator.userAgent || navigator.vendor || window.opera;
      
      const checkIPhone = /iPhone/i.test(userAgent);
      setIsIPhone(checkIPhone);
    }
  }, []);*/
  if (!demandeInfo) {
    return <Spinner />;
  }

  return !uploadToast || filesX.length == 0 ? (
    <>
      <h1 className=" title flexCenter text-center">
        Brouillon de la demande{" "}
      </h1>
      <div className="flexCenter">
        {loading ? (
          <Spinner />
        ) : (
          <form
            className="w-3/4 max-w-lg mt-4 space-y-4"
            onSubmit={formik.handleSubmit}
          >
            <div className="flex flex-col w-full">
              Sélectionner la spécialité correspondant à votre demande :
              <Select
                value={formik.values.specialite}
                onChange={(e) => {
                  formik.handleChange(e);
                }}
                id="specialite"
                text={"Sélectionner  une spécialité"}
                className="relative mb-2 mt-2"
                options={specialites}
                required={true}
                style={{ cursor: "not-allowed" }}
                disabled
              ></Select>
              {formik.values.specialite === "dermatologie" && (
                <>
                  Sélectionner le type de lésion correspondant :
                  <Select
                    value={formik.values.type}
                    onChange={(e) => {
                      formik.handleChange(e);
                    }}
                    id="type"
                    text={"Type de lésion"}
                    className="relative mb-2 mt-2"
                    options={category}
                    required={true}
                    style={{ cursor: "not-allowed" }}
                    disabled
                  ></Select>
                </>
              )}
            </div>

            <>
              <RecursiveContainer
                genre={gender}
                config={
                  props.type === "Dermatose non tumorale"
                    ? formConfigDermatose
                    : formConfigTummerCutane
                }
                formik={formik}
              />

              {/* Step 1: Human Body Selection */}
        {!confirm && (
          <div className="body-step flex flex-col items-center space-y-6 w-full">
            <HumanCard
              selectedPart={currentEntry.selectedPart}
              onSelectPart={(part: string | null) => {
                const newEntries = [...entries];
                newEntries[currentIndex].selectedPart = part;
                setEntries(newEntries);
              }}
            />
            {currentEntry.selectedPart && (
              <button
                type="button"
                className="px-6 py-2 bg-blue-600 text-white font-medium rounded-lg shadow-md hover:bg-blue-700"
                onClick={() => setConfirm(true)}
              >
                ✔ Confirmer la zone
              </button>
            )}
          </div>
        )}

        {/* Step 2: Upload Zone */}
        {confirm && (
          <section className="flex flex-col items-center w-full space-y-4">
            <div className="w-full flex justify-center">
              <button
                type="button"
                onClick={() => cameraInputRef.current?.click()}
                className="w-full sm:w-auto px-5 py-3 bg-green-600 hover:bg-green-700 text-white font-medium rounded-lg shadow flex items-center justify-center gap-2 cursor-pointer transition-colors"
              >
                📷 Prendre une photo
              </button>

              <input
                ref={cameraInputRef}
                type="file"
                accept="image/*"
                capture="environment"
                onChange={handleCameraCapture}
                style={{ display: "none" }}
              />
            </div>
            <div
              {...getRootProps({
                className:
                  "dropzone flexCenter w-full border-2 border-dashed border-gray-300 rounded-lg p-6 hover:border-blue-500 cursor-pointer",
              })}
            >
              <input {...getInputProps()} />
              <p className="text-center text-gray-500">
                Glissez les images pour : <strong>{currentEntry.selectedPart ?? "aucune zone sélectionnée"}</strong>
              </p>
            </div>

            {currentEntry.files.length > 0 && (
              <aside className="thumbsContainer flex flex-wrap gap-4 mt-4 w-full">
                {currentEntry.files.map((file, index) => (
                  <div
                    key={index}
                    className="w-24 h-24 border border-gray-300 rounded-lg overflow-hidden flex items-center justify-center"
                  >
                    <img
                            src={URL.createObjectURL(file)}
                            alt={`preview-${index}`}
                            className="w-full h-full object-cover"
                          />
                  </div>
                ))}
              </aside>
            )}


            {currentEntry.files.length > 0 && (
              <>
                <label className="mt-4 ">
                  Ancienneté de la lésion <span className="text-red-600">(*)</span>
                </label>
                <input
                  type="text"
                  placeholder=""
                  value={entries[currentIndex].anciennete}
                  onChange={(e) => {
                    const newEntries = [...entries];
                    newEntries[currentIndex].anciennete = e.target.value;
                    setEntries(newEntries);
                  }}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400 mt-4"
                />
                <label className="mt-4">
                  Taille (mm) <span className="text-red-600">(*)</span>
                </label>
                <input
                  type="number"
                  placeholder=""
                  value={entries[currentIndex].taille}
                  onChange={(e) => {
                    const newEntries = [...entries];
                    newEntries[currentIndex].taille = e.target.value;
                    setEntries(newEntries);
                  }}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
                />

                <label className="mt-4">
                  Douleur <span className="text-red-600">(*)</span>
                </label>
                <div className="flex gap-4">
                  {["oui", "non", "inconnue"].map((val) => (
                    <label key={val} className="flex items-center gap-1 mt-3">
                      <input
                        type="radio"
                        name={`douleur-${currentIndex}`}
                        value={val}
                        checked={entries[currentIndex].douleur === val}
                        onChange={() => {
                          const newEntries = [...entries];
                          newEntries[currentIndex].douleur = val as "oui" | "non" | "inconnue";
                          setEntries(newEntries);
                        }}
                      />
                      {val}
                    </label>
                  ))}
                </div>
                <input
                  type="text"
                  placeholder="Message..."
                  value={currentEntry.message}
                  onChange={(e) => {
                    const newEntries = [...entries];
                    newEntries[currentIndex].message = e.target.value;
                    setEntries(newEntries);
                  }}
                  className="w-full px-4 py-2 border rounded-lg"
                />
                <button
                  type="button"
                  onClick={() => {
                    setEntries([
                      ...entries,
                      { selectedPart: null, files: [], message: "" },
                    ]);
                    setCurrentIndex(entries.length);
                    setConfirm(false);
                  }}
                  className="px-6 py-2 bg-blue-600 text-white font-medium rounded-lg shadow-md hover:bg-blue-700 transition-colors duration-300 mt-4"
                >
                  + Ajouter une autre zone
                </button>
              </>
            )}

            {
              currentEntry.files.length>0 && qualityData && (
                <>
                <QualityAnalysis data={qualityData} />
                  {qualityData?.overall_quality !== "accept" && (
                    <div className="flex justify-center">
                      <button
                        type="button"
                        onClick={removeLastPhoto}
                        className="mt-4 mb-4 px-6 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition"
                      >
                        Reprendre la photo
                      </button>
                    </div>
                  )}
                </>
              )
            }
          </section>
        )}

        {/* Carousel of all entries */}
        {entries.length > 0 && (
          <Carousel
            entries={entries}
            onDeleteImage={handleDeleteImage}
            onDeleteEntry={handleDeleteEntry}
          />
        )}
              
              {_.isEmpty(teleexpertList) ? (
                <>
                  <img
                    src={alert}
                    alt="alerte"
                    className="absolute top-35 left-8"
                    width="40"
                  />
                  <p
                    style={{
                      fontSize: "17px",
                      color: "#4565f6",
                      textAlign: "justify",
                    }}
                  >
                    {user?.groupId ? (
                      <>
                        {" "}
                        Aucun expert n'est disponible dans votre groupe, votre
                        demande sera transmise à un médecin expert de notre
                        réseau.
                      </>
                    ) : (
                      <>
                        {" "}
                        Aucun expert n'est disponible dans votre département,
                        votre demande sera transmise à un médecin expert de
                        notre réseau.
                      </>
                    )}
                  </p>
                </>
              ) : (
                <div className="flex flex-col w-full">
                  <Select
                    id="expertId"
                    value={formik?.values?.docExpert}
                    onChange={(selectedOption) => {
                      formik.setFieldValue(
                        "docExpert",
                        selectedOption.target.value
                      );
                    }}
                    //onChange={formik.handleChange}
                    text={"Sélectionner un téléexpert"}
                    className="relative mb-2 mt-2"
                    //disabled={_.isEmpty(teleexpertList)}
                    options={(_.isEmpty(previousDoctor)
                      ? teleexpertList?.map((e) => ({
                          value: e._id,
                          label:
                            e.lastName +
                            " " +
                            e.firstName +
                            " (" +
                            e.departement +
                            ")",
                        }))
                      : teleexpertList
                          ?.map((e) => ({
                            value: e._id,
                            label:
                              e.lastName +
                              " " +
                              e.firstName +
                              " (" +
                              e.departement +
                              ")",
                          }))
                          .concat(previousDoctor)
                    ).filter((option) =>
                      teleexpertList.some(
                        (doctor) => doctor._id === option.value
                      )
                    )}
                  ></Select>

                  {formik?.values?.docExpert ? null : (
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <img src={alert} alt="alerte" width="40" />
                      <p
                        style={{
                          fontSize: "17px",
                          color: "#4565f6",
                          textAlign: "justify",
                        }}
                      >
                        {user?.groupId ? (
                          groupData?.doctorId?.length === 1 ? (
                            <>
                              Aucun expert de votre département n'a été
                              sélectionné, votre demande sera transmise à un
                              médecin expert de notre réseau national.{" "}
                            </>
                          ) : (
                            <>
                              Aucun expert de votre groupe n'a été sélectionné,
                              votre demande sera transmise à un médecin expert
                              de notre réseau national.
                            </>
                          )
                        ) : (
                          <>
                            Aucun expert de votre département n'a été
                            sélectionné, votre demande sera transmise à un
                            médecin expert de notre réseau national.
                          </>
                        )}
                      </p>
                    </div>
                  )}
                </div>
              )}
              <div className="relative mt-2  ml-2 mr-2 ">
                <Button
                  status="primary"
                  className="float-right flexCenter mb-5"
                  width="200px"
                  height="50px"
                  onClick={() => {
                    setDispatch(true);
                  }}
                  disabled={loading || (dispatch && !!!formik.isValid)}
                >
                  {loading ? (
                    <div className="animate-spin rounded-full h-4 w-4 border-t-2 border-b-2 border-purple-500"></div>
                  ) : (
                    "Envoi de la demande"
                  )}
                </Button>
                <Button
                  status="secondary"
                  className=" flexCenter mb-5"
                  width="200px"
                  height="50px"
                  type="submit"
                  disabled={loading}
                  onClick={() => {
                    setDispatch(false);
                  }}
                >
                  {loading ? (
                    <div className="animate-spin rounded-full h-4 w-4 border-t-2 border-b-2 border-purple-500"></div>
                  ) : (
                    "Sauvegarder"
                  )}
                </Button>
              </div>
            </>
          </form>
        )}
      </div>
    </>
  ) : (
    <div className="w-full px-6  ">
      <div className="font-bold text-gray-700 ">
        Téléchargement d'images en cours...
      </div>{" "}
      <div className="w-full  bg-gray-300 rounded-full ">
        <div
          className={`${
            progress == 0 ? "" : "bg-Blue-Primary"
          } text-xs font-medium text-white text-center px-0.5 leading-none rounded-full`}
          style={{ width: `${progress}%` }}
        >
          {" "}
          {progress}%
        </div>
      </div>{" "}
    </div>
  );
};

export default DynamicContainer;
